export const civilities = [ "Monsieur", "Madame" ,"Maitre" ] as const
export type civilityType = typeof civilities[number]

// personne morale
export type LegalEntityType = {
    rcs: string,
    companyName: string,
    legalForm: string,
    capital: number,
    postalCode: string,
    city: string,
    address: string,
    additionalAddress: string,
    registrationOffice: string,
    isRcsRegistering?: boolean,
    cities?: string[]
}


export type LegalEntityTypeOfficiant = {
    companyName: string,
    Denomination: string,
    civility: civilityType,
    mode: string,
    nom: string,
    prenom: string,
    legalForm: string,
    capital: number,
    postalCode: string,
    decisionNature: string,
    city: string,
    address: string,
    additionalAddress: string,
    registrationOffice: string,
    isRcsRegistering?: boolean,
    cities?: string[],
    dateofficiant: string,
}

export type Tribunal = {
    greffe: string,
    dateDépot: string,
    numeroRole: string,
    
}
// personne morale avec representateur
export type LegalEntityWithRepresentativeType = {
    rcs: string,
    companyName: string,
    legalForm: string,
    capital: number,
    postalCode: string,
    city: string,
    address: string,
    additionalAddress: string,
    registrationOffice: string,
    isRcsRegistering?: boolean,
    cities?: string[],
    civility: civilityType,
    lastName: string,
    firstName: string
}